import { Fragment, useEffect, useState } from "react";

import "react-lazy-load-image-component/src/effects/blur.css";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import "swiper/css";
import "swiper/css/pagination";
import { setLanguage } from "../../core/feature/language/languageSlice";
import {} from "../../core/feature/store";
import { setToken } from "../../core/feature/token/tokenSlice";
import { setUser } from "../../core/feature/user/userSlice";
import { credentialCheck } from "../../core/service/api";
import { i18n } from "../../translations/i18n";
import { StatsInvoice } from "../common/home/Stats";

// import required modules
import { useTranslation } from "react-i18next";
import { BackButton } from "../common/BackButton";
import { ChevronLeft, X } from "lucide-react";
import { SwitchIcon } from "../savingComponent/icons";
import Config from "../../config/Config";
import { SavingInformationComponent } from "./components/savingsInformationComponents";
import { Dialog, Tab, Transition } from "@headlessui/react";
import { QuickAmountComponent } from "./components/quickAmountComponent";
import { ManualInputComponent } from "./components/manualInputComponent";
import moment from "moment";
import { formatCurrency } from "../../config/global";
import { FormType } from "./savingCreateMobile";
import { setLoading } from "../../core/feature/config/configSlice";
import { getConfigSavings, sumbitSaving } from "../../core/service/api_saving";
import { toast } from "react-toastify";

const SavingCreateWeb = (props: any) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const env = Config.BaseUrlDev;

  const [activeUser, setActiveUser] = useState<any>();
  const [activeAccount, setActiveAccount] = useState<any>();
  const [amount, setAmount] = useState<number>(0);
  const [savingsData, setSavingsData] = useState<any>({});

  const [isOpenConfirm, setIsOpenConfirm] = useState<boolean>(false);

  function getImgContent(url: string) {
    return env + "main_a/image/get/" + url + "/pas";
  }

  function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(" ");
  }

  const handleChangeValue = (value: number) => {
    setAmount(value);
  };

  const openConfirm = () => {
    setIsOpenConfirm(true);
  };

  const dismissConfirm = () => {
    setIsOpenConfirm(false);
  };

  const handleSave = async () => {
    console.log(activeAccount.balance);

    if (!savingsData.unlimitedMaxBalance) {
      if (
        Number(activeAccount.balance) + amount >
        savingsData.maxBalanceLimit
      ) {
        return toast.warn(
          `Tabungan tidak dapat ditambahkan, maksimal saldo tabungan ${formatCurrency(savingsData.maxBalanceLimit)}`,
        );
      }
    }
    if (savingsData.minBalanceSaving > 0) {
      if (amount < savingsData.minBalanceSaving) {
        return toast.warning(
          `Minimal setoran ${formatCurrency(savingsData.minBalanceSaving)}.`,
        );
      }
    }

    const form: FormType = {
      callerId: activeUser.callerId,
      amount: amount,
      configId: activeAccount?.configId,
      channel: "MOBILE",
      tag: "",
    };
    try {
      dispatch(setLoading(true));
      const { data } = await sumbitSaving(form);
      dispatch(setLoading(false));
      toast.success("Success");
      console.log(data);

      navigate("/saving/mutation", {
        state: {
          data,
          activeUser,
        },
      });
    } catch (error) {
      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    setActiveUser(location.state.activeUser[0] ?? {});
    setActiveAccount(location.state.savingAccount ?? {});

    getConfigSavings(location.state.savingAccount.configId).then(
      ({ data }: any) => {
        console.log(data);
        setSavingsData(data);
      },
    );

    console.log("active acount", location.state.savingAccount);
  }, location.state);

  return (
    <div className="bg-psp-primary mb-8 font-montserrat">
      <StatsInvoice />
      <div className="h-auto flex bg-psp-primary mt-10">
        <div className="mx-none  container h-full flex-row flex justify-between relative mb-16">
          <div className="flex flex-col rounded-2xl -top-36 relative bg-white items-center py-2 px-8  w-full my-2 mx-1 divide-y">
            <div className="w-full">
              <div className="flex d-flex w-full justify-start gap-4 mt-4">
                <button>
                  <ChevronLeft
                    className="bg-white w-8 h-8 rounded-lg border p-1"
                    onClick={() => navigate(`/saving`)}
                  />
                </button>
                <div className="font-bold text-2xl">
                  {t("SAVING.createSaving")}
                </div>
              </div>
              <section className="my-4 w-full">
                <div className="flex h-28 w-full bg-white rounded-xl">
                  <div className="flex justify-between w-full">
                    <div className="flex items-center justify-between h-20 px-4 mt-3">
                      <img
                        src={
                          getImgContent(activeUser?.photoUrl) ||
                          "https://i.pinimg.com/736x/9e/83/75/9e837528f01cf3f42119c5aeeed1b336.jpg"
                        }
                        alt=""
                        className="w-20 h-20 rounded-full object-cover mr-6"
                      />
                      <div className="font-montserrat">
                        <h1
                          style={{ fontSize: 18 }}
                          className={`m-0 text-sm mb-2`}
                        >
                          {activeUser?.name ?? "-"}
                        </h1>
                        <h1
                          style={{ fontSize: 14 }}
                          className={`m-0 font-normal`}
                        >
                          {activeUser?.callerId ?? "-"}
                        </h1>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
            <section className="flex w-full">
              <div className="w-1/2 p-3 border-r">
                <SavingInformationComponent
                  hasBorder={true}
                  data={savingsData}
                  savingsAccount={activeAccount}
                />
              </div>
              <div className="w-1/2 p-3">
                <span className="font-semibold">{t("SAVING.inputAmount")}</span>
                <Tab.Group
                  onChange={(index) => {
                    console.log("Changed selected tab to:", index);
                  }}
                >
                  <Tab.List className="flex space-x-1 justify-around p-1 mt-3">
                    <Tab
                      className={({ selected }) =>
                        classNames(
                          "w-1/3 py-2.5 text-sm font-medium px-2",
                          " ",
                          selected
                            ? "font-montserrat border-b-2 border-blue-700 text-blue-700 text-sm font-semibold active:border-b-2 focus:border-b-2"
                            : "text-slate-400 font-montserrat text-sm font-semibold",
                        )
                      }
                    >
                      {t("SAVING.quickInput")}
                    </Tab>
                    <Tab
                      className={({ selected }) =>
                        classNames(
                          "w-1/3 py-2.5 text-sm font-medium px-2",
                          " ",
                          selected
                            ? "font-montserrat border-b-2 border-blue-700 text-blue-700 text-sm font-semibold active:border-b-2 focus:border-b-2"
                            : "text-slate-400 font-montserrat text-sm font-semibold",
                        )
                      }
                    >
                      {t("SAVING.manualInput")}
                    </Tab>
                  </Tab.List>
                  <Tab.Panels>
                    <Tab.Panel>
                      <QuickAmountComponent
                        data={activeAccount}
                        onChangeValue={handleChangeValue}
                      />
                    </Tab.Panel>
                    <Tab.Panel>
                      <ManualInputComponent onChangeValue={handleChangeValue} />
                    </Tab.Panel>
                  </Tab.Panels>
                </Tab.Group>
              </div>
            </section>
            <section className="w-full flex justify-end p-3">
              <button
                className="px-12 py-2 bg-blue-700 rounded-full text-white"
                onClick={() => openConfirm()}
              >
                Confirm
              </button>
            </section>
          </div>
          <Transition appear show={isOpenConfirm} as={Fragment}>
            <Dialog as="div" className="relative z-10" onClose={dismissConfirm}>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-black bg-opacity-25" />
              </Transition.Child>

              <div className="fixed inset-0 overflow-y-auto">
                <div className="flex min-h-full items-center justify-center p-4 text-center">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0 scale-95"
                    enterTo="opacity-100 scale-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100 scale-100"
                    leaveTo="opacity-0 scale-95"
                  >
                    <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-psp-primary p-6 text-left align-middle shadow-xl transition-all">
                      <Dialog.Title
                        as="h3"
                        className="text-lg font-medium leading-6 text-gray-900"
                      >
                        <div className="flex flex-row justify-between items-center">
                          <div>{t("SAVING.confirmTitle")}</div>
                          <button onClick={() => dismissConfirm()}>
                            <X />
                          </button>
                        </div>
                      </Dialog.Title>
                      <div className="flex flex-col gap-1">
                        <span className="mt-4 font-semibold">
                          {t("SAVING.confirmation")}
                        </span>
                        <div className="flex justify-between items-center mt-4 text-sm">
                          <span>{t("SAVING.transactionType")}</span>
                          <span>{t("SAVING.saving")}</span>
                        </div>
                        <div className="flex justify-between items-center text-sm">
                          <span>{t("SAVING.savingType")}</span>
                          <span>{activeAccount?.savingName}</span>
                        </div>
                        <div className="flex justify-between items-center text-sm">
                          <span>{t("SAVING.transactionTime")}</span>
                          <span>
                            {moment(Date.now()).format("DD-MM-YYYY, HH.mm")}
                          </span>
                        </div>

                        <div className="flex justify-between items-center text-sm">
                          <span>{t("SAVING.callerName")}</span>
                          <span>{activeUser?.name}</span>
                        </div>
                        <div className="flex justify-between items-center text-sm">
                          <span>NIS</span>
                          <span>{activeUser?.callerId}</span>
                        </div>
                        <div className="flex justify-between items-center text-sm font-bold">
                          <span>{t("SAVING.total")}</span>
                          <span>{formatCurrency(amount)}</span>
                        </div>
                      </div>
                      <div className="flex gap-2 z-[1000] mt-4">
                        <button
                          onClick={() => dismissConfirm()}
                          className={`disabled:bg-psp-gray w-full shadow-lg py-2.5 text-sm font-semibold rounded-full bg-danger text-white`}
                        >
                          {t("PROFILE.cancel")}
                        </button>
                        <button
                          onClick={() => handleSave()}
                          className={`disabled:bg-psp-gray w-full shadow-lg  py-2.5 text-sm font-semibold rounded-full bg-blue-700 text-white`}
                        >
                          {t("PROFILE.confirm")}
                        </button>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition>
        </div>
      </div>
    </div>
  );
};

export default SavingCreateWeb;
